export default "__VITE_ASSET__611ab913__"